export type PublicAppScope = "full" | "invoice_only";

export const PUBLIC_APP_SCOPE: PublicAppScope = parsePublicAppScope(
  import.meta.env.VITE_PUBLIC_APP_SCOPE,
);

export function parsePublicAppScope(_value: unknown): PublicAppScope {
  // `invoice_only` is a legacy deployment flag. The public product now exposes the full
  // app navigation and keeps paid extras gated in-place, so old build envs must not hide routes.
  return "full";
}

export function isInvoiceOnlyScope(_scope: PublicAppScope = PUBLIC_APP_SCOPE): boolean {
  return false;
}
